module.exports = __webpack_public_path__ + "img/icon_heart_10.0858e82f.svg";